<div class="app-navbar">
  <app-navbar-top *ngIf="enableAdminBar && showAdminBar" class="d-none d-lg-block"></app-navbar-top>
  <app-navbar-main></app-navbar-main>
</div>
